<template>
  <div id="contenedor-main-licitacion-junta-aclaraciones">
    <listado :licitacionParticipantes="getlicitacionParticipantes" />
    <v-dialog
      v-if="esteParticipante"
      v-model="mostrarVentanaAgregarAperturaPropuesta"
      width="75%">
      <agregar-apertura-propuesta
        :participanteLicitacion="esteParticipante"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
    <v-dialog
      v-if="esteParticipante"
      v-model="mostrarVentanaEditarAperturaPropuesta"
      width="75%">
      <editar-apertura-propuesta
        :participanteLicitacion="esteParticipante"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import eventBus from '@/helpers/eventBus';
import AgregarAperturaPropuesta from '@/components/administracion/licitaciones/aperturapropuestas/Nueva.vue';
import EditarAperturaPropuesta from '@/components/administracion/licitaciones/aperturapropuestas/Editar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'MainLicitacionAperturaPropuestas',
  components: {
    Listado,
    AgregarAperturaPropuesta,
    EditarAperturaPropuesta,
  },

  data() {
    return {
      mostrarVentanaAgregarAperturaPropuesta: false,
      mostrarVentanaEditarAperturaPropuesta: false,
      esteParticipante: null,
      idLicitacion: this.$route.params.idLicitacion,
    };
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarVentanaEditarAperturaPropuesta = false;
      this.mostrarVentanaAgregarAperturaPropuesta = false;
      this.esteParticipante = null;
    },
  },
  computed: {
    getlicitacionParticipantes() {
      if (!this.licitacionParticipantes) return [];
      return this.licitacionParticipantes;
    },
  },
  mounted() {
    eventBus.$on('agregar-propuesta-participante', (participanteLicitacion) => {
      this.esteParticipante = participanteLicitacion;
      this.mostrarVentanaAgregarAperturaPropuesta = true;
    });
    eventBus.$on('editar-propuesta-participante', (participanteLicitacion) => {
      this.esteParticipante = participanteLicitacion;
      this.mostrarVentanaEditarAperturaPropuesta = true;
    });
  },
};
</script>

<style lang="scss">
</style>
